import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import store from '../store/index';
import { useRouter } from "vue-router";
import productParam from '@/utils/vipRedirect'
const $router = useRouter();

class HttpRequest {
    private readonly baseUrl: string;
    constructor() {
        this.baseUrl = 'https://api.vipshop.elco-cloud.cn/'
    }
    getInsideConfig() {
        console.log('store2',store.state.token)
        const config = {
            baseURL: this.baseUrl,// 所有的请求地址前缀部分(没有后端请求不用写)  
            timeout: 80000, // 请求超时时间(毫秒)
            withCredentials: true,// 异步请求携带cookie
            headers: {
                'Content-Type': 'application/json',
                'Access-token': window.localStorage.getItem(`accessToken${window.localStorage.getItem('currentState')}`),
                'brand': store.state.currentState === 'clinique' || window.localStorage.getItem('currentState') === 'clinique' ? 'CL' : 'OR',
                'X-Requested-With': 'XMLHttpRequest',
            },
        }
        return config
    }

    // 请求拦截
    interceptors(instance: AxiosInstance, url: string | number | undefined) {
        
        instance.interceptors.request.use(config => {
            return config
        }, (error: any) => {
            console.log('error111==>', error)
            return Promise.reject(error)
        })

        //响应拦截
        instance.interceptors.response.use(res => {
            //返回数据
            const { data } = res
            console.log('返回数据处理', res)
            return data
        }, (error: any) => {
            console.log('error111==>', error)
            if (error && error.response.data) {
                switch (error.response.data.errorCode) {
                  case 401:
                    let str = new URL(window.location.href);
                    window.localStorage.clear()
                    const _params = str.search.split('state=')[1];
                    if(_params) {
                        const _brand = _params.split('&')[0];
                        window.location.href = productParam(_brand);
                    }else {
                        const currnetState = window.localStorage.getItem('currentState')
                        window.location.href = productParam(currnetState);
                    }
                   
                    break;
                  default:
                }
            }
            return Promise.reject(error)

        })
    }

    request(options: AxiosRequestConfig) {
        const instance = axios.create()
        options = Object.assign(this.getInsideConfig(), options)
        this.interceptors(instance, options.url)
        return instance(options)
    }
}

const http = new HttpRequest()

export default http;